import React from 'react';
import { ReactComponent as XIcon } from 'assets/icons/ui-elements/small/x-mark-sm.svg';
import { CalendarEvent } from 'pages/Agenda/utils/eventUtils';
import { EventColorSet } from 'pages/Agenda/utils/eventColors';
import { HeaderContent, HeaderTopRow, HeaderMeta, HeaderTitle, CloseButton, HeaderFields, HeaderField } from './styled';

interface ModalHeaderProps {
  event: CalendarEvent;
  isCompletedView: boolean;
  colorSet: EventColorSet;
  onClose: () => void;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ event, colorSet, onClose }) => {
  return (
    <>
      <HeaderContent backgroundColor={colorSet.backgroundColor} borderColor={colorSet.borderColor}>
        <HeaderTopRow>
          <HeaderMeta>
            <HeaderTitle fontColor={colorSet.fontColor}>Plano: {event.aplicacao}</HeaderTitle>
          </HeaderMeta>
          <CloseButton onClick={onClose} aria-label="Fechar modal">
            <XIcon />
          </CloseButton>
        </HeaderTopRow>

        <HeaderFields>
          <HeaderField fontColor={colorSet.fontColor}>
            <strong>Unidade:</strong> {event.title}
          </HeaderField>
          <HeaderField fontColor={colorSet.fontColor}>
            <strong>Ambiente:</strong> {event.areaNome || '-'}
          </HeaderField>
          <HeaderField fontColor={colorSet.fontColor}>
            <strong>Equipamento:</strong> {event.equipamento || '-'}
          </HeaderField>
          <HeaderField fontColor={colorSet.fontColor}>
            <strong>
              {event.qtdAtividades} {event.qtdAtividades === 1 ? 'atividade' : 'atividades'}
            </strong>{' '}
            ({event.horasPrevistas})
          </HeaderField>
        </HeaderFields>
      </HeaderContent>
    </>
  );
};
